import { useState } from "react";

/**
 * Open/closed presentation state for a collapsible accordion section.
 * @param {boolean} [defaultOpen=false] - Whether the section starts expanded.
 * @returns {{ isOpen: boolean, toggle: () => void }}
 */
export function useAccordion(defaultOpen = false) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const toggle = () => setIsOpen((previous) => !previous);

    return { isOpen, toggle };
}
